import {createSyncStoragePersister} from '@tanstack/query-sync-storage-persister';

/**
 * Web persister using synchronous localStorage.
 * Returns null in environments where localStorage is unavailable
 * (Safari private mode, server-side rendering, jsdom without localStorage).
 * Returning null causes persistQueryClient() to be skipped gracefully.
 */
export const createPlatformPersister = () => {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  return createSyncStoragePersister({storage: window.localStorage});
};
